'use client';

import { getFbCookies } from './getFbCookies';
import { sendServerEvent } from './sendServerEvent';

declare global {
  interface Window {
    fbq?: (
      action: 'track' | 'trackCustom' | 'init' | 'consent',
      eventNameOrPixelId: string,
      params?: Record<string, unknown>,
      options?: { eventID?: string },
    ) => void;
  }
}

interface TrackConversionArgs {
  eventName: string;
  email?: string;
  sourceUrl?: string;
  formId?: string;
  formValues?: Record<string, string>;
  customData?: Record<string, string>;
}

/**
 * The server event goes first: the platform holds the form's skip conditions,
 * so only its answer says whether this conversion counts. A refusal keeps the
 * pixel quiet; anything else - success or a failed request - fires it, sharing
 * the event id so Meta deduplicates the two.
 */
export async function trackConversion({
  eventName,
  email,
  sourceUrl,
  formId,
  formValues,
  customData,
}: TrackConversionArgs): Promise<void> {
  const eventId = crypto.randomUUID();
  const { _fbp, _fbc } = getFbCookies();
  const currentUrl =
    sourceUrl || (typeof window !== 'undefined' ? window.location.href : '');

  const { skipped } = await sendServerEvent({
    eventName,
    eventId,
    sourceUrl: currentUrl,
    email,
    fbp: _fbp,
    fbc: _fbc,
    formId,
    formValues,
    customData,
  });

  if (skipped || typeof window === 'undefined') return;

  try {
    window.fbq?.('track', eventName, customData, { eventID: eventId });
  } catch (err) {
    console.error('[Meta Pixel] Failed to fire browser event:', err);
  }
}
